import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProposalSendBack from '../../../widgets/proposalRevise/ProposalSendBack'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getProposalRevise, getProposalReviseNew } from '../../../redux/actions/proposalRevise'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProposalSendBackNew from '../../../widgets/proposalRevise/ProposalSendBackNew'

export default function ProposalReviseResquest() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProposalReviseNew(proposalId)
      //console.log('call api => ', JSON.stringify(_schema))

      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    //console.log('load ProposalRevise proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader
            header={schema?.model?.header}
            subHeader={schema?.model?.subHeader}
            isNotCallApi
          />

          {schema?.model?.forms?.ProjectFeedback && (
            <ProposalSendBackNew schema={schema.model.forms.ProjectFeedback} />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
